module.exports = __webpack_public_path__ + "media/marketing_area/dynamic-1f42b27c.png";